export function debouncedPromise(f, ms) {
    let timer = null;
    let resolves = [];

    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            const result = f(...args);
            resolves.forEach(r => r(result));
            resolves = [];
        }, ms);

        return new Promise(r => resolves.push(r));
    };
}



// WEBPACK FOOTER //
// ./common/async_helper.js